import { ActionFunction, redirect, replace } from 'react-router-dom';
import { client } from '~/api/client';
import { submitMutation } from '~/api/data/responses';
import { mapResult } from '~/api/data/result';
import {
  CreateAccountDocument,
  CreateAccountMutation,
  CreateAccountMutationVariables,
  CreateCertificateDocument,
  CreateCertificateMutation,
  CreateCertificateMutationVariables,
  UpdateAccountDocument,
  UpdateAccountMutation,
  UpdateAccountMutationVariables
} from '~/api/graphql';

export const createAccount = async (input: CreateAccountMutationVariables['input']) =>
  mapResult(
    await client.mutate<CreateAccountMutation, CreateAccountMutationVariables>({
      mutation: CreateAccountDocument,
      variables: { input }
    }),
    (data) => data?.createAccount
  );

export const updateAccount = async (id: string, input: UpdateAccountMutationVariables['input']) =>
  mapResult(
    await client.mutate<UpdateAccountMutation, UpdateAccountMutationVariables>({
      mutation: UpdateAccountDocument,
      variables: { id, input }
    }),
    (data) => data?.updateAccount
  );

export const createCertificateOfLiabilityInsurance = async (
  input: CreateCertificateMutationVariables['input']
) =>
  mapResult(
    await client.mutate<CreateCertificateMutation, CreateCertificateMutationVariables>({
      mutation: CreateCertificateDocument,
      variables: { input }
    }),
    (data) => data?.createCertificate
  );

export const submitCreateAccount: ActionFunction = async ({ request }) =>
  submitMutation(createAccount(await request.json()), (account) =>
    redirect(`/app/accounts/${account?.id}/overview`)
  );

export const submitUpdateAccount: ActionFunction = async ({ params, request }) =>
  submitMutation(updateAccount(params.id || '', await request.json()), (account) =>
    redirect(`/app/accounts/${account?.id}/overview`)
  );

export const submitCreateCertificateOfLiabilityInsurance: ActionFunction = async ({
  params,
  request
}) =>
  submitMutation(createCertificateOfLiabilityInsurance(await request.json()), (certificate) =>
    replace(`/app/accounts/${params.id}/certificates/${certificate?.id}`)
  );
